import { createQuery } from "@/api/utils/createQuery";
import { File } from "./File.model";

export const getFiles = createQuery<File[]>(async ({ api, router }) => {
    const response = await api.get(
        `/file/files?company_id=in.("${router.params.companyId}")`,
    );

    return response.items;
});

type FileInfo = { id: string; name: string };
type FileTree = { id: string; name: string; ancestors: FileTree[] };

const flattenFileTree = (tree: FileTree): FileInfo[] => {
    const result: FileInfo[] = [{ id: tree.id, name: tree.name }];

    if (tree.ancestors && tree.ancestors.length > 0) {
        tree.ancestors.forEach((ancestor) => {
            result.push(...flattenFileTree(ancestor));
        });
    }

    return result;
};

export const getAncestors = createQuery<
    { root: File; children: FileInfo[] },
    { fileId: string }
>(async ({ api, params }) => {
    const response: FileTree = await api.get(
        `/file/files/${params.fileId}/ancestors`,
    );

    const flattened = flattenFileTree(response).reverse();

    const root = flattened[0];

    const fileData = await api.get(`/file/files/${root.id}`);

    return {
        root: fileData,
        children: flattened.slice(1),
    };
});
